const numberedList = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return <ol {...attributes}>{children}</ol>;
    },
    PreviewElement: ({ attributes, children }) => {
        return <ol {...attributes}>{children}</ol>;
    },
};

export default numberedList;
